import React from "react";
import {
  ContactSectionWrapper,
  ContactContainer,
  LogoContainer,
  LogoText,
  ContactInfo,
  ContactInfoHeading,
  ContactInfoDetails,
  ContactInfoLink,
  CreditsSection,
  CreditsText,
  CreditsLink,
} from "../Styles/StylesContactSection.js";

const ContactSection = () => {
  return (
    <ContactSectionWrapper>
      <ContactContainer>
        {/* Left Logo Container */}
        <LogoContainer>
          <LogoText>Enjoy Real Estate</LogoText>
        </LogoContainer>

        {/* Contact Information */}
        <ContactInfo>
          <ContactInfoHeading>Michal Johnson</ContactInfoHeading>
          <ContactInfoDetails>Sotheby’s International Realty</ContactInfoDetails>
          <ContactInfoLink href="mailto:leapot@enjoyaspen.com">
            leapot@niyaz2025.com
          </ContactInfoLink>
          <ContactInfoDetails>9734 379 8125</ContactInfoDetails>
          <ContactInfoDetails>Avenue</ContactInfoDetails>
          <ContactInfoDetails>Aspen, U.S.A.</ContactInfoDetails>
        </ContactInfo>

        {/* Right Logo Container */}
        <LogoContainer>
          <LogoText>Sotheby’s Realty</LogoText>
        </LogoContainer>
      </ContactContainer>

      {/* Credits Section */}
      <CreditsSection>
        <CreditsText>
          All images are sourced from{" "}
          <CreditsLink
            href="https://www.google.com/search?q=pixels+images&rlz=1C1CHZN_enIN1077IN1078&oq=pixe&gs_lcrp=EgZjaHJvbWUqBggAEEUYOzIGCAAQRRg7MgYIARBFGDkyBwgCEAAYjwIyBwgDEAAYjwIyBwgEEAAYjwLSAQg1MzU0ajBqN6gCCLACAQ&sourceid=chrome&ie=UTF-8"
            target="_blank"
            rel="noopener noreferrer"
          >
            Pexels
          </CreditsLink>
          .
        </CreditsText>
      </CreditsSection>
    </ContactSectionWrapper>
  );
};

export default ContactSection;
